import { 
  signInWithEmailAndPassword, 
  signOut, 
  onAuthStateChanged,
  createUserWithEmailAndPassword,
  getAuth as getFirebaseAuth
} from 'firebase/auth';
import { initializeApp, getApp, deleteApp } from 'firebase/app';
import { 
  collection, 
  query, 
  where, 
  getDocs 
} from 'firebase/firestore';
import { auth, db, firebaseConfig } from './firebase';

export const authService = {
  async login(email, password) {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      return userCredential.user;
    } catch (error) {
      console.error("Login error:", error);
      throw error;
    }
  },

  async logout() {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Logout error:", error);
      throw error;
    }
  },

  // Helper to wait for Firebase Auth to initialize
  waitForAuth() {
    return new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        unsubscribe();
        resolve(user);
      });
    });
  },

  // Get the shop associated with the current user
  async getCurrentShop() {
    let user = auth.currentUser;
    if (!user) {
      user = await this.waitForAuth();
    }
    
    if (!user) return null;

    try {
      const q = query(collection(db, 'shops'), where('ownerId', '==', user.uid));
      const querySnapshot = await getDocs(q);
      if (!querySnapshot.empty) {
        return { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
      }
      return null;
    } catch (error) {
      console.error("Error getting current shop:", error);
      return null;
    }
  },

  // Create a new user in Firebase Auth without logging out the current user
  async createMerchantAuth(email, password) {
    let secondaryApp;
    try {
      // Initialize a secondary app instance
      secondaryApp = initializeApp(firebaseConfig, 'SecondaryApp');
      const secondaryAuth = getFirebaseAuth(secondaryApp);
      
      const userCredential = await createUserWithEmailAndPassword(secondaryAuth, email, password);
      const uid = userCredential.user.uid;
      
      // Sign out from secondary app (important)
      await signOut(secondaryAuth);
      
      return uid;
    } catch (error) {
      console.error("Error creating merchant auth:", error);
      throw error;
    } finally {
      if (secondaryApp) {
        await deleteApp(secondaryApp);
      }
    }
  }
};
